import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Divider,
} from "@mui/material"
import {useEffect, useState} from "react";
import SuccessfullSolicitation from "../components/SuccessfullSolicitation";
import Box from "@mui/material/Box";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import {useNavigate} from "react-router-dom";
import {Icon} from "@iconify/react";
import toast from "react-hot-toast";
import {
    Solicitation,
    SolicitationFields,
    WorkflowSolicitationDTO
} from "../../../types/solicitation/solicitationData";
import {Client, ClientFields} from "../../../types/client/clientData";
import {LoaderBlockUI} from "../../../components/loader";
import {HttpClient} from "../../../http/client/httpClient";
import {EntityWithIdFields} from "../../../types/baseEntities";
import {HttpSolicitation} from "../../../http/solicitation/httpSolicitation";
import SolicitationDocumentation from "../../solicitation-view/components/SolicitationDocumentation";
import {HttpSolicitationOnboarding} from "../../../http/solicitation/httpSolicitationOnboarding";

interface StepRequestedDocumentationProps {
    handlePrev: () => void,
    clientId: number,
    clientSolicitationId: number
}

const StepRequestedDocumentation = ({ handlePrev, clientId, clientSolicitationId }: StepRequestedDocumentationProps) => {
    const [openSucceed, setOpenSucceed] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const navigate = useNavigate()
    const [client, setClient] = useState<Client>()
    const [solicitation, setSolicitation] = useState<Solicitation>()


    useEffect(() => {
        HttpClient.getById(clientId).then(r => setClient(r))
        HttpSolicitation.getSolicitationById(clientSolicitationId).then(r => setSolicitation(r))
    }, [])
    
    const handleFinish = () => {
        if(solicitation && client) {
            HttpSolicitationOnboarding.getStepResult(solicitation[EntityWithIdFields.Id], 5)
                .then((r) => {
                    if (!r.tieneError) {
                        const data: WorkflowSolicitationDTO = {
                            [SolicitationFields.BankCode]: solicitation[SolicitationFields.BankCode],
                            [SolicitationFields.BranchCode]: solicitation[SolicitationFields.BranchCode],
                            [SolicitationFields.SolicitationTypeCode]: solicitation[SolicitationFields.SolicitationTypeCode],
                            [ClientFields.BusinessName]: client[ClientFields.BusinessName],
                            [ClientFields.CUIT]: client[ClientFields.CUIT]
                        }
                        setLoading(true)
                        HttpSolicitation.insertWorkflow(solicitation[EntityWithIdFields.Id], data).then(() => {
                            setOpenSucceed(true)
                        }).catch((e) => toast.error(e)).finally(() => setLoading(false))
                    }
                    else {
                        toast.error(r.descripcionError)
                    }
                })
        }
    }

    return (
        <Card>
            <CardHeader title={!openSucceed ? "Documentación" : 'Éxito'}
                action={!openSucceed &&
                    <Button color='secondary' variant='contained' onClick={() => navigate('/solicitudes')} startIcon={<KeyboardBackspaceOutlinedIcon />}>
                        Inicio
                    </Button>
                }
            />
            <Divider />
            <CardContent>
                {
                    (!openSucceed) &&
                    <SolicitationDocumentation solicitationId={clientSolicitationId} dropSize={'small'} canDelete/>
                }
                {openSucceed && <SuccessfullSolicitation />}
            </CardContent>
            <CardActions>
            {
                !openSucceed &&
                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color='secondary' variant='contained' onClick={handlePrev} startIcon={<Icon icon='mdi:chevron-left' fontSize={20} />}>
                        Atrás
                    </Button>
                    <Button variant='contained' color='success' onClick={handleFinish} endIcon={<Icon icon='mdi:chevron-right' fontSize={20} />}>
                        Finalizar
                    </Button>
                </Box>
            }

            </CardActions>
            {
                loading && <LoaderBlockUI/>
            }
        </Card>
    )
}


export default StepRequestedDocumentation